import { isNotInRange } from "../../utils/customFunctions";

export const validateDailyRecommendationData = async ({ date, title }) => {
	const errors = {};
	if (!date) {
		errors.date = "daily-recommendations.validationErrors.required.date";
	}

	if (!title) {
		errors.title = "daily-recommendations.validationErrors.required.title";
	}

	if (title && isNotInRange({ min: 3, max: 25, str: title })) {
		errors.title = "daily-recommendations.validationErrors.required.minMax";
	}

	return errors;
};
